import { useTranslation } from "react-i18next";
import Navbar from "../../components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import ConceptSection from "./components/ConceptSection";
import FeaturesSection from "./components/FeaturesSection";
import DetailsSection from "./components/DetailsSection";
import ContentSection from "./components/ContentSection";
import TuitionSection from "./components/TuitionSection";
import InstructorSection from "./components/InstructorSection";
import VoicesSection from "./components/VoicesSection";
import RegistrationSection from "./components/RegistrationSection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";
import Footer from "./components/Footer";

export default function HomePage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ConceptSection />
      <FeaturesSection />
      <DetailsSection />
      <ContentSection />
      <TuitionSection />
      <InstructorSection />
      <VoicesSection />
      <RegistrationSection />
      <FAQSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
